/*  
  Component responsible for displaying notification messages

  Messages are displayed by dispatching to redux with the following type and payload
  type: 'app/notify'
  payload: { message: String = '', severity: ['error', 'info', 'success', 'warning'] = 'info', duration: int = 3000, sx: MuiSxObj = {} }

  example usage

  dispatch({
    type: 'app/notify',
    payload: {
      message: "User create successfully!",
      severity: 'success',
      duration: 10000,
    },
  })
*/

import Snackbar from '@mui/material/Snackbar'
import Alert from '@mui/material/Alert'
import Slide from '@mui/material/Slide'
import { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'

const mapStateToProps = ({ app }) => ({ data: app.notifyData })

const GlobalSnackbar = ({ dispatch, data }) => {
  const [open, setOpen] = useState(false)
  const timerRef = useRef()

  const { message = '', severity = 'info', duration = 3000, sx = {} } = data || {}

  useEffect(() => {
    if (data) {
      if (timerRef.current) {
        clearTimeout(timerRef.current)
      }
      setOpen(true)
    }
  }, [data])

  const handleClose = () => {
    setOpen(false)
    timerRef.current = setTimeout(() => {
      dispatch({ type: 'app/notify' })
    }, 200)
  }

  return (
    <Snackbar
      ContentProps={{ sx: { background: 'white', color: 'black' } }}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      open={open}
      onClose={handleClose}
      autoHideDuration={duration}
      TransitionComponent={props => <Slide {...props} direction="up" />}
    >
      <Alert
        variant="filled"
        onClose={handleClose}
        severity={severity}
        sx={{ width: '100%', ...sx }}
        elevation={6}
      >
        {message}
      </Alert>
    </Snackbar>
  )
}

export default connect(mapStateToProps)(GlobalSnackbar)
